// extracted by mini-css-extract-plugin
export var editProfile = "EditProfile_editProfile__esOba";
export var form = "EditProfile_form__RVVjl";
export var btnSave = "EditProfile_btnSave__UKujE";
export var btnDisconnect = "EditProfile_btnDisconnect__Nhu1J";
export var rotate = "EditProfile_rotate__wuovR";
export var dotty = "EditProfile_dotty__JC1Q8";